import React, { Component } from "react";
import { convertDateFormat } from "../../utils/helperFunctions";

import { MDBBtn, MDBDataTable } from "mdbreact";
import { Row, Col, Button } from "reactstrap";
import Pagination from "../Common/Pagination";
import { translate } from "react-i18next";

class DeviceTable extends Component {
  state = {
    loadTable: false,
    gatewayList: [],
    pagination: {},
  };
  columns = [
    {
      label: this.props.t("dashboard.devicesID"),
      field: "deviceId",
      sort: "asc",
      width: 150,
    },
    {
      label: this.props.t("dashboard.deviceName"),
      field: "name",
      sort: "asc",
      width: 150,
    },
    {
      label: this.props.t("dashboard.gatewayID"),
      field: "gatewayId",
      sort: "asc",
      width: 150,
    },
    {
      label: this.props.t("dashboard.equipmentType"),
      field: "equipmentType",
      sort: "asc",
      width: 150,
    },
    {
      label: this.props.t("dashboard.equipmentStatus"),
      field: "equipmentStatus",
      sort: "asc",
      width: 150,
    },
    {
      label: this.props.t("dashboard.deviceOfflineAlerts"),
      field: "offlineAlarmEnable",
      sort: "asc",
      width: 150,
    },
    {
      label: this.props.t("dashboard.frequency"),
      field: "LoraFreq",
      sort: "asc",
      width: 150,
    },
    {
      label: this.props.t("dashboard.createdAt"),
      field: "createdAt",
      sort: "asc",
      width: 150,
    },
    {
      label: this.props.t("dashboard.location"),
      field: "locationDisplay",
      sort: "asc",
      width: 150,
    },
    {
      label: this.props.t("dashboard.action"),
      field: "action",
      width: 80,
    },
  ];

  componentDidMount() {
    const { devices } = this.props;
    if (devices && devices.length) {
      this.showTable(true);
    } else {
      this.showTable(false);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.devices !== this.props.devices &&
      this.props.devices &&
      this.props.devices.length
    ) {
      this.showTable(true);
    }
  }

  showTable = (loadTable) => {
    if (loadTable) {
      const { devices, editDevice, deleteDevice, pagination } = this.props;

      const rows = devices.map((device, index) => {
        let deviceRow = { ...device };
        delete deviceRow["userId"];
        deviceRow.gatewayId =
          (deviceRow.gateway && deviceRow.gateway.name) || "-";
        deviceRow.locationDisplay =
          (deviceRow.location && deviceRow.location.name) || "-";
        deviceRow.LoraFreq =
          deviceRow.latestData &&
          deviceRow.latestData.nodeData &&
          deviceRow.latestData.nodeData.LoraFreq
            ? deviceRow.latestData.nodeData.LoraFreq
            : "N/A";
        deviceRow.equipmentType = deviceRow.equipmentType || "N/A";
        deviceRow.equipmentStatus = deviceRow.equipmentStatus
          ? this.props.t("dashboard.active")
          : this.props.t("dashboard.inActive");
        deviceRow.offlineAlarmEnable = deviceRow.offlineAlarmEnable
          ? this.props.t("dashboard.enabled")
          : this.props.t("dashboard.disabled");
        deviceRow.createdAt = convertDateFormat(
          deviceRow.createdAt,
          "shortDateTime"
        );
        deviceRow.action = (
          <>
            <MDBBtn
              onClick={deleteDevice.bind(this, deviceRow.id)}
              tag="a"
              rounded
              size="sm"
              className="px-2 transparentBtn"
            >
              <i className="fas fa-trash mt-0"></i>
            </MDBBtn>
            <MDBBtn
              onClick={editDevice.bind(this, deviceRow)}
              tag="a"
              rounded
              size="sm"
              className="px-2 transparentBtn"
            >
              <i className="fas fa-pencil-alt mt-0"></i>
            </MDBBtn>
          </>
        );
        return deviceRow;
      });
      this.setState({
        loadTable,
        deviceList: {
          columns: this.columns,
          rows: rows,
        },
        pagination,
      });
    } else {
      this.setState({ loadTable });
    }
  };

  render() {
    const { changePage, t } = this.props;
    const { loadTable, deviceList, pagination } = this.state;

    return (
      <React.Fragment>
        {loadTable ? (
          <>
            <MDBDataTable
              className="recentAlarmTable border-0"
              bordered
              data={deviceList}
              paging={false}
              scrollX
              searchLabel={t("dashboard.search")}
            />
            <Row className="mt-3 mb-3 text-center">
              <Col lg={12}>
                {/* {pagination.totalPages !== pagination.currentPage &&
                  <Button
                    color="info"
                    onClick={changePage}
                  >Load More
                  </Button>
                } */}
                {/* <label>
                  {/* Showing {pagination.currentPage * 10 - 9} to{' '}
                  {pagination.currentPage * 10} of all results 
                </label> */}
              </Col>
              {/* <Col lg={6} >
      
                {/* <Pagination
                  pagination={pagination}
                  changePage={changePage}></Pagination> 
            </Col> */}
            </Row>
          </>
        ) : null}
      </React.Fragment>
    );
  }
}

export default translate("translations")(DeviceTable);
